import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'
import cardFilterRule from 'const/cardFilterRule'

export const NAMESPACE = 'KanBo/Board/views/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_IS_PUBLIC = NAMESPACE + 'SET_IS_PUBLIC'
export const SET_POSITION = NAMESPACE + 'SET_POSITION'
export const SET_SETTINGS = NAMESPACE + 'SET_SETTINGS'
export const SET_PENDING_SETTINGS = NAMESPACE + 'SET_PENDING_SETTINGS'
export const ADD_PENDING_SETTINGS = NAMESPACE + 'ADD_PENDING_SETTINGS'
export const FILTER_RESET = NAMESPACE + 'FILTER_RESET'
export const FILTER_SET_MATCH_ALL = NAMESPACE + 'FILTER_SET_MATCH_ALL'
export const FILTER_ADD_RULE = NAMESPACE + 'FILTER_ADD_RULE'
export const FILTER_REMOVE_RULE = NAMESPACE + 'FILTER_REMOVE_RULE'

const defaultBoardState = {
  views: [],
}

const initialState = {
  viewsById: {}
}

const SETTINGS_VERSION = 2

export default function reducer (state: any = initialState, action: any = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case ADD:
      return state[action.payload.boardId] ? {
        ...state,
        viewsById: {
          ...state.viewsById,
          [action.payload.view.id]: {
            ...action.payload.view,
            settings:
              (
                action.payload.view.settings &&
                action.payload.view.settings.v === SETTINGS_VERSION
              ) ? action.payload.view.settings : {
                v: SETTINGS_VERSION
              }
          }
        },
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          views: addUniqueValueToArray({
            array: state[action.payload.boardId].views,
            value: action.payload.view.id,
            index: action.payload.view.index
          }),
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        viewsById: { ...state.viewsById },
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          views: [ ...state[action.payload.boardId].views ],
        }
      }

      action.payload.array.forEach(view => {
        newState[action.payload.boardId].views = addUniqueValueToArray({
          array: newState[action.payload.boardId].views,
          value: view.id,
          index: view.index
        })
        newState.viewsById[view.id] = {
          ...view,
          settings:
          (
            !view.settings ||
            !view.settings.v ||
            view.settings.v === SETTINGS_VERSION
          ) ? view.settings : {
            v: SETTINGS_VERSION
          }
        }
      })

      return newState
    }
    case REMOVE: {
      let removedElement = false

      const newState = {
        ...state,
      }

      if (newState.viewsById[action.payload.viewId]) {
        delete newState.viewsById[action.payload.viewId]
        removedElement = true
      }

      Object.keys(newState).forEach(key => {
        if (newState[key].views) {
          const index = newState[key].views.findIndex(id => id === action.payload.viewId)

          if (index !== -1) {
            newState[key].views = [
              ...newState[key].views.slice(0, index),
              ...newState[key].views.slice(index + 1)
            ]

            removedElement = true
          }
        }
      })

      return removedElement ? newState : state
    }
    case SET_NAME:
      return state.viewsById[action.payload.viewId] ? {
        ...state,
        viewsById: {
          ...state.viewsById,
          [action.payload.viewId]: {
            ...state.viewsById[action.payload.viewId],
            name: action.payload.name
          }
        }
      } : state
    case SET_IS_PUBLIC:
      return state.viewsById[action.payload.viewId] ? {
        ...state,
        viewsById: {
          ...state.viewsById,
          [action.payload.viewId]: {
            ...state.viewsById[action.payload.viewId],
            isPublic: action.payload.isPublic
          }
        }
      } : state
    case SET_POSITION:
      return state.viewsById[action.payload.viewId] ? {
        ...state,
        viewsById: {
          ...state.viewsById,
          [action.payload.viewId]: {
            ...state.viewsById[action.payload.viewId],
            position: action.payload.position
          }
        }
      } : state
    case SET_SETTINGS:
      return (
        state.viewsById[action.payload.viewId] &&
        (
          !action.payload.settings.v ||
          action.payload.settings.v === SETTINGS_VERSION
        )
      ) ? {
        ...state,
        viewsById: {
          ...state.viewsById,
          [action.payload.viewId]: {
            ...state.viewsById[action.payload.viewId],
            settings: action.payload.settings
          }
        }
      } : state
    case SET_PENDING_SETTINGS:
      return state.viewsById[action.payload.viewId] ? {
        ...state,
        viewsById: {
          ...state.viewsById,
          [action.payload.viewId]: {
            ...state.viewsById[action.payload.viewId],
            pendingSettings: action.payload.pendingSettings
          }
        }
      } : state
    case ADD_PENDING_SETTINGS:
      return state.viewsById[action.payload.viewId] ? {
        ...state,
        viewsById: {
          ...state.viewsById,
          [action.payload.viewId]: {
            ...state.viewsById[action.payload.viewId],
            pendingSettings: {
              ...state.viewsById[action.payload.viewId]?.pendingSettings,
              ...action.payload.pendingSettings,
            }
          }
        }
      } : state
    case FILTER_RESET:
      return state.viewsById[action.payload.viewId] ? {
        ...state,
        viewsById: {
          ...state.viewsById,
          [action.payload.viewId]: {
            ...state.viewsById[action.payload.viewId],
            pendingSettings: {
              ...state.viewsById[action.payload.viewId]?.pendingSettings,
              filter: {}
            }
          }
        }
      } : state
    case FILTER_SET_MATCH_ALL:
      return setFilterItem(state, action, 'matchAll')
    case FILTER_ADD_RULE:
      return addRule(state, action)
    case FILTER_REMOVE_RULE:
      return removeRule(state, action)
    default: return state
  }
}

export function add ({ boardId, view }) {
  return {
    type: ADD,
    payload: {
      boardId,
      view,
    }
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array
    }
  }
}

export function remove ({ viewId }) {
  return {
    type: REMOVE,
    payload: {
      viewId
    }
  }
}

export function setName ({ viewId, name }) {
  return {
    type: SET_NAME,
    payload: {
      viewId,
      name
    }
  }
}

export function setIsPublic ({ viewId, isPublic }) {
  return {
    type: SET_IS_PUBLIC,
    payload: {
      viewId,
      isPublic
    }
  }
}

export function setPosition ({ viewId, position }) {
  return {
    type: SET_POSITION,
    payload: {
      viewId,
      position
    }
  }
}

export function setSettings ({ viewId, settings }) {
  return {
    type: SET_SETTINGS,
    payload: {
      viewId,
      settings
    }
  }
}

export function setPendingSettings ({ viewId, pendingSettings }) {
  return {
    type: SET_PENDING_SETTINGS,
    payload: {
      viewId,
      pendingSettings
    }
  }
}

export function addPendingSettings ({ viewId, pendingSettings }) {
  return {
    type: ADD_PENDING_SETTINGS,
    payload: {
      viewId,
      pendingSettings
    }
  }
}

export function reset ({ viewId }) {
  return {
    type: FILTER_RESET,
    payload: {
      viewId
    }
  }
}

export function setMatchAll ({ viewId, matchAll }) {
  return {
    type: FILTER_SET_MATCH_ALL,
    payload: {
      viewId,
      matchAll
    }
  }
}

export function addFilterRule ({ viewId, rule }) {
  return {
    type: FILTER_ADD_RULE,
    payload: {
      viewId,
      rule,
    }
  }
}

export function removeFilterRule ({ viewId, rule }) {
  return {
    type: FILTER_REMOVE_RULE,
    payload: {
      viewId,
      rule,
    }
  }
}

function setFilterItem (state, action, filterName) {
  const viewId = action.payload.viewId

  let pendingFilter = state.viewsById[viewId]?.pendingSettings?.filter

  if (!pendingFilter) {
    pendingFilter = state.viewsById[viewId]?.settings?.filter
  }

  return {
    ...state,
    viewsById: {
      ...state.viewsById,
      [viewId]: {
        ...state.viewsById[viewId],
        pendingSettings: {
          ...state.viewsById[viewId]?.pendingSettings,
          filter: {
            ...pendingFilter,
            [filterName]: action.payload[filterName]
          }
        }
      }
    }
  }
}

function addRule (state, { payload: { viewId, rule } }) {
  let pendingFilter = state.viewsById[viewId]?.pendingSettings?.filter

  if (!pendingFilter) {
    pendingFilter = state.viewsById[viewId]?.settings?.filter
  }

  const rules = pendingFilter?.rules || []

  const ruleKey = cardFilterRule[rule.type].getKey(rule)

  const index = rules.findIndex(_rule => cardFilterRule[_rule.type].getKey(_rule) === ruleKey)

  return {
    ...state,
    viewsById: {
      ...state.viewsById,
      [viewId]: {
        ...state.viewsById[viewId],
        pendingSettings: {
          ...state.viewsById[viewId]?.pendingSettings,
          filter: {
            ...pendingFilter,
            rules: 
              index === -1 ? [
                {
                  ...rule,
                },
                ...rules
              ] : [
                ...rules.slice(0, index),
                {
                  ...rule,
                },
                ...rules.slice(index + 1)
              ]
          }
        }
      }
    }
  }
}

function removeRule (state, { payload: { viewId, rule } }) {
  let pendingFilter = state.viewsById[viewId]?.pendingSettings?.filter

  if (!pendingFilter) {
    pendingFilter = state.viewsById[viewId]?.settings?.filter
  }

  const rules = pendingFilter?.rules || []

  const ruleKey = cardFilterRule[rule.type].getKey(rule)

  const index = rules.findIndex(_rule => cardFilterRule[_rule.type].getKey(_rule) === ruleKey)

  if (index === -1) return state

  return {
    ...state,
    viewsById: {
      ...state.viewsById,
      [viewId]: {
        ...state.viewsById[viewId],
        pendingSettings: {
          ...state.viewsById[viewId]?.pendingSettings,
          filter: {
            ...pendingFilter,
            rules: [
              ...rules.slice(0, index),
              ...rules.slice(index + 1)
            ]
          }
        }
      }
    }
  }
}